module.exports = __webpack_public_path__ + "img/DE00406.61dd43f2.png";